var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.92308,
    cy: 17,
    r: 1.92308,
    fill: "#1A3763"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3077,
    cy: 8.53846,
    r: 1.92308,
    fill: "#1A3763"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3461,
    cy: 19.8846,
    r: 2.11538,
    fill: "#0B97D5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.65386,
    cy: 7.57693,
    r: 1.73077,
    fill: "#D2ECF8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2307,
    cy: 15.0769,
    r: 1.53846,
    fill: "#D2ECF8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9615,
    cy: 3.73077,
    r: 1.73077,
    fill: "#0B97D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88464 16.4231L9.69234 13.3462",
    stroke: "#1A3763",
    strokeWidth: 0.961538
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3846 12L18.7308 9.11539",
    stroke: "#1A3763",
    strokeWidth: 0.961538
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4231 10.4615L12.7692 3.92307",
    stroke: "#0B97D5",
    strokeWidth: 0.961538
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6154 14.6923L12.9615 19.5",
    stroke: "#0B97D5",
    strokeWidth: 0.961538
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11533 10.8462L6.23071 7.96155",
    stroke: "#D2ECF8",
    strokeWidth: 0.769231
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7692 13.1538L15.8461 15.0769",
    stroke: "#D2ECF8",
    strokeWidth: 0.769231
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8461,
    cy: 12.3846,
    r: 2.69231,
    fill: "#1A3763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDs1);
export default __webpack_public_path__ + "static/media/ds_1.f63982e192d8d13a89a461d1e0bf91f1.svg";
export { ForwardRef as ReactComponent };